<template>
  <div style="position: relative">
    <FilterFields
      :fields="[
        {
          type: 'text',
          label: 'Nome',
          field: 'nome',
        },
        {
          type: 'select',
          label: 'Status',
          field: 'ativo',
          options: ['Todos', 'Ativo', 'Inativo'],
        },
      ]"
    />
    <TableApp
      titulo="Ambientes"
      acaoBtn="/#/restauranteAmbientes/novo"
      textoBtn="Novo"
      api-url="/restaurante/ambientes"
      :fields="fields"
      ref="ambientes"
      :perPage="10"
    >
      <template slot="customRow" scope="props">
        <span v-if="props.field == 'ativo'">
          <span
            v-if="props.rowData.ativo == true"
            class="label label-lg label-inline label-light-success"
            >Ativo</span
          >
          <span v-else class="label label-lg label-inline label-light-danger"
            >Inativo</span
          >
        </span>
        <span v-if="props.field == 'actions'">
          <div class="row-actions" style="text-align: right !important">
            <span style="overflow: visible; position: relative; width: 180px">
              <div class="dropdown dropdown-inline">
                <router-link
                  class="btn btn-sm btn-light-primary btn-hover-primary btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Mesas'"
                  :to="{
                    name: 'restauranteAmbientesMesas',
                    params: {
                      ambienteId: props.rowData.id,
                    },
                    query: {
                      ambiente_nome: props.rowData.nome,
                    },
                  }"
                >
                  <TableFurniture :size="16" title="Mesas" />
                </router-link>
                <router-link
                  class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Editar'"
                  :to="{
                    name: 'restauranteAmbientesEditar',
                    params: {
                      id: props.rowData.id,
                    },
                  }"
                >
                  <Pencil :size="16" title="Editar" />
                </router-link>
                <button
                  @click="excluir(props.rowData)"
                  class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                  v-b-tooltip.hover.bottom="'Excluir'"
                >
                  <TrashCanIcon :size="16" />
                </button>
              </div>
            </span>
          </div>
        </span>
      </template>
    </TableApp>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableFurniture from "vue-material-design-icons/TableFurniture.vue";
import TableApp from "@/components/Table/Table2";
import FilterFields from "@/components/FilterFields";

export default {
  name: "app-restaurante-ambientes",
  components: {
    Pencil,
    TrashCanIcon,
    TableFurniture,
    TableApp,
    FilterFields,
  },
  data() {
    return {
      fields: [
        {
          label: "Nome",
          field: "nome",
          type: "text",
          sortable: true,
          width: "35%",
        },
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          sortable: false,
          width: "35%",
        },
        {
          label: "Status",
          field: "ativo",
          type: "text",
          sortable: true,
          slot: true,
          width: "15%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "15%",
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o ambiente " + data.nome + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/restaurante/ambientes/delete", {
              id: data.id,
            });

            this.$refs.ambientes.refresh();
            this.$toast.success("Ambiente excluído!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
